var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('OCheckBox',{staticClass:"language",attrs:{"label":_vm.language.name},model:{value:(_vm.isSelected),callback:function ($$v) {_vm.isSelected=$$v},expression:"isSelected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }